import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toastComponent?: any;

  register(component: any) {
    this.toastComponent = component;
  }

  show(message: string) {
    this.toastComponent?.show(message);
  }
}